// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/history.js';

import { paths } from '../generated/history';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('history', Original, paths);
